export default "__VITE_ASSET__DYTrmaU9__"